package team.platforma.multiplatform_material_extension.util.gestures

import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.input.pointer.PointerInputChange
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.onGloballyPositioned
import team.platforma.multiplatform_material_extension.calendar.calendar_regular.api.CalendarRegular


@Composable
fun rememberHorizontalGestures(): HorizontalGestures {
    return remember { HorizontalGesturesImpl() }
}

/**
 * Инициализация перехвата жестов пользователя, для анимации переключения календаря.
 * @author Evgeny Minaenkov
 * @see [rememberHorizontalGestures]
 * @sample HorizontalGesturesInitializeSample
 *
 */
fun Modifier.horizontalGestures(horizontalGestures: HorizontalGestures?): Modifier {
    return this.pointerInput(Unit) {
        detectHorizontalDragGestures(
            onDragStart = {
                horizontalGestures?.onDragStart(it)
            },
            onHorizontalDrag = { change, dragAmong ->
                horizontalGestures?.onHorizontalDrag(change, dragAmong)
            },
            onDragCancel = {
                horizontalGestures?.onDragCancel()
            },
            onDragEnd = {
                horizontalGestures?.onDragEnd()
            }
        )
    }.onGloballyPositioned { layoutCoordinates ->
        horizontalGestures?.width(layoutCoordinates.size.width.toFloat())
    }
}

interface HorizontalGestures {
    fun width(float: Float)
    fun onDragStart(offset: Offset)
    fun onHorizontalDrag(change: PointerInputChange, dragAmount: Float)
    fun onDragCancel()
    fun onDragEnd()
    fun addListener(listener: HorizontalGesturesListener)
    fun removeListener(listener: HorizontalGesturesListener)
}

interface HorizontalGesturesListener {
    fun width(float: Float)
    fun onDragStart(offset: Offset)
    fun onHorizontalDrag(change: PointerInputChange, dragAmount: Float)
    fun onDragCancel()
    fun onDragEnd()

}

private class HorizontalGesturesImpl : HorizontalGestures {
    private val listeners = mutableListOf<HorizontalGesturesListener>()
    override fun width(float: Float) {
        listeners.forEach { it.width(float) }
    }

    override fun onDragStart(offset: Offset) {
        listeners.forEach { it.onDragStart(offset) }
    }

    override fun onHorizontalDrag(change: PointerInputChange, dragAmount: Float) {
        listeners.forEach { it.onHorizontalDrag(change, dragAmount) }
    }

    override fun onDragCancel() {
        listeners.forEach { it.onDragCancel() }
    }

    override fun onDragEnd() {
        listeners.forEach { it.onDragEnd() }
    }

    override fun addListener(listener: HorizontalGesturesListener) {
        listeners.add(listener)
    }

    override fun removeListener(listener: HorizontalGesturesListener) {
        listeners.remove(listener)
    }
}

@Composable
private fun HorizontalGesturesInitializeSample() {
    val horizontalGestures = rememberHorizontalGestures()

    LazyColumn {
        item {
            CalendarRegular(
                modifier = Modifier.horizontalGestures(horizontalGestures),
                onDateSelected = {},
                horizontalGestures = horizontalGestures
            )
        }
    }

}



